module.exports = __webpack_public_path__ + "./images/icomoon.368b6e.svg";